export function downloadFile(response, filename) {
  // Определяем тип данных (если он не указан, используем text/csv по умолчанию)
  const mimeType =
    response.headers?.['content-type'] || 'text/csv;charset=utf-8;'

  const blobData =
    response.data instanceof Blob
      ? response.data
      : new Blob([response.data], { type: mimeType })

  const url = window.URL.createObjectURL(blobData)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
